const initialState = {
  data: undefined,
  errorMessage: null,
  isLoading: false,
  isFulfilled: false,
  isRejected: false,
};

export const DropdownVillagesData = (state = initialState, action) => {
  switch (action.type) {
    case "GET_DROPDOWN_VILLAGES_PENDING":
      return {
        ...state,
        isLoading: true,
        isRejected: false,
        isFulfilled: false,
      };
    case "GET_DROPDOWN_VILLAGES_REJECTED":
      return {
        ...state,
        isLoading: false,
        isRejected: true,
        errorMessage: action.payload.response.data ?? null,
      };
    case "GET_DROPDOWN_VILLAGES_FULFILLED":
      return {
        ...state,
        isLoading: false,
        isFulfilled: true,
        data: action.payload.response.data ?? null,
      };
    default:
      return state;
  }
};
